<ul class="nav nav-pill shadow flex-column bg-white">

    <!-- <li class="nav-item mt-xl-9">
        <a class="nav-link position-relative p-0 py-xl-3 px-xl-3" [routerLink]="['/employee']"
            routerLinkActive="border-2 bg-light border-secondary border-left" [routerLinkActiveOptions]="{exact:true}">
            <i-bs name="house" width="1em" height="1em"></i-bs>
            <span class="pl-2">Dashboard</span>
        </a>
    </li> -->
    <li class="nav-item mt-xl-9">
        <button class="btn btn-link h6  text-primary text-decoration-none p-0 py-xl-3 px-xl-3" [disabled]="id == null" [routerLink]="['/employee']"
            routerLinkActive="border-2 bg-light border-secondary border-left" [routerLinkActiveOptions]="{exact:true}">
            <i-bs name="house" width="1em" height="1em"></i-bs>
            <span class="pl-2">Dashboard</span>
        </button>
    </li>
    <li class="nav-item mt-xl-9">
        <a class="nav-link position-relative p-0 py-xl-3 px-xl-3" [routerLink]="['/employee/profile']"
            routerLinkActive="border-2 bg-light border-secondary border-left" [routerLinkActiveOptions]="{exact:true}">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Profile</span>
        </a>
    </li>
    <li class="nav-item mt-xl-9">
      <div class="col-md-9 d-flex align-items-center">
        <!-- <button class="btn btn-link h6  text-primary text-decoration-none" [disabled]="step < 2"
          style="cursor: default;" [routerLink]="['/employee/profile/contact']">
          Contact Details
          <i-bs *ngIf="step > 2" name="check-circle-fill" class="text-success ml-2"></i-bs>
        </button> -->
      </div>
        <button class="btn btn-link h6  text-primary text-decoration-none p-0 py-xl-3 px-xl-3" [disabled]="step < 2 || step == 7" [routerLink]="['/employee/profile/contact']"
            routerLinkActive="border-2 bg-light border-secondary border-start" [routerLinkActiveOptions]="{exact:true}">
            <i-bs  name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Contact Details</span>
        </button>
    </li>
    <li class="nav-item mt-xl-9">
        <!-- <a class="nav-link position-relative p-0 py-xl-3 px-xl-3" [routerLink]="['/employee/profile/thumb']"
            routerLinkActive="border-2 bg-light border-secondary border-left" [routerLinkActiveOptions]="{exact:true}">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Photo & Sign</span>
        </a> -->
        <button class="btn btn-link h6  text-primary text-decoration-none p-0 py-xl-3 px-xl-3" [disabled]="step < 3 || step == 7" [routerLink]="['/employee/profile/thumb']"
            routerLinkActive="border-2 bg-light border-secondary border-left" [routerLinkActiveOptions]="{exact:true}">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Photo & Sign</span>
        </button>
    </li>
    <li class="nav-item mt-xl-9">
        <button class="btn btn-link h6  text-primary text-decoration-none p-0 py-xl-3 px-xl-3" [disabled]="step < 4 || step == 7"
            [routerLink]="['/employee/service-book/present-place']"
            routerLinkActive="border-2 bg-light border-secondary border-left" [routerLinkActiveOptions]="{exact:true}">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Present Place/School</span>
        </button>
        <!-- <a class="nav-link position-relative p-0 py-xl-3 px-xl-3"
            [routerLink]="['/employee/service-book/present-place']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Present Place/School</span>
        </a> -->
    </li>
    <li class="nav-item mt-xl-9">
        <button class="btn btn-link h6  text-primary text-decoration-none p-0 py-xl-3 px-xl-3"  [disabled]="step < 5 || step == 7"
            [routerLink]="['/employee/service-book']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Service Record</span>
        </button>
        <!-- <a class="nav-link position-relative p-0 py-xl-3 px-xl-3" [routerLink]="['/employee/service-book']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Service Record</span>
        </a> -->
    </li>
    <li class="nav-item mt-xl-9">
        <button class="btn btn-link h6  text-primary text-decoration-none p-0 py-xl-3 px-xl-3" [disabled]="step < 6 || step == 7" [routerLink]="['/employee/profile/other-details']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Priority Category</span>
        </button>
        <!-- <a class="nav-link position-relative p-0 py-xl-3 px-xl-3" [routerLink]="['/employee/profile/other-details']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Priority Category</span>
        </a> -->
    </li>

    <!-- <li class="nav-item mt-xl-9">
        <button class="btn btn-link h6  text-primary text-decoration-none p-0 py-xl-3 px-xl-3" [disabled]="step < 7"
            [routerLink]="['/employee/transfer-request']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Transfer Request</span>
        </button>
    </li> -->
    <li class="nav-item mt-xl-9">
      <a class="nav-link position-relative p-0 py-xl-3 px-xl-3" [routerLink]="['/employee/transfer-request']"
          routerLinkActive="border-2 bg-light border-secondary border-left">
          <i-bs name="hash" width="1em" height="1em"></i-bs>
          <span class="pl-2">Transfer Request</span>
      </a>
  </li>
    <!-- <li class="nav-item mt-xl-9">
        <a class="nav-link position-relative p-0 py-xl-3 px-xl-3" [routerLink]="['/employee/grievance']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            <i-bs name="hash" width="1em" height="1em"></i-bs>
            <span class="pl-2">Grievance</span>
        </a>
    </li> -->
</ul>


<!-- <div class="steps clearfix">
  <ul role="tablist" class="list-unstyled position-relative">
  <li class="my-3">
    <div class="row">
      <div class="col-md-2">
        <h5
          class="h5 d-flex align-items-center justify-content-center  text-primary rounded-circle avatar-sm mr-4 text-center"
          [ngClass]="{'bg-them-danger-1 text-primary': step > 0, 'bg-secondary text-primary': step == 0, 'border border-3 border-theme-alternate text-primary': step < 0}">
          <i-bs name="house" width="1em" height="1em"></i-bs>
        </h5>
      </div>
      <div class="col-md-9 d-flex align-items-center">
        <button class="btn btn-link h6  rounded-circle text-primary text-decoration-none"
          [routerLink]="['/employee']">
          <span class="pl-2">Dashboard</span>
        </button>
      </div>
    </div>
  </li>
    <li class="my-3">
      <div class="row">
        <div class="col-md-2">
          <h5
            class="h5 d-flex align-items-center justify-content-center  text-primary rounded-circle avatar-sm mr-4 text-center"
            [ngClass]="{'bg-them-danger-1 text-primary': step > 1, 'bg-secondary text-primary': step == 1, 'border border-3 border-theme-alternate text-primary': step < 1}">
            1
          </h5>
        </div>
        <div class="col-md-9 d-flex align-items-center">
          <button class="btn btn-link h6  text-primary text-decoration-none"
            [routerLink]="['/employee/profile']">
            Profile
          </button>
        </div>
      </div>
    </li>
    <li class="my-3">
      <div class="row">
        <div class="col-md-2">
          <h5
            class="h5 d-flex align-items-center justify-content-center  text-primary rounded-circle avatar-sm mr-4 text-center"
            [ngClass]="{'bg-them-danger-1 text-primary': step > 2, 'bg-secondary text-primary': step == 2, 'border border-3 border-theme-alternate text-primary': step < 2}">
            2
          </h5>
        </div>
        <div class="col-md-9 d-flex align-items-center">
          <button class="btn btn-link h6  text-primary text-decoration-none" [disabled]="step < 2"
            style="cursor: default;" [routerLink]="['/employee/profile/contact']">
            Contact Details
            <i-bs *ngIf="step > 2" name="check-circle-fill" class="text-success ml-2"></i-bs>
          </button>
        </div>
      </div>
    </li>
    <li class="my-3">
      <div class="row">
        <div class="col-md-2">
          <h5
            class="h5 d-flex align-items-center justify-content-center  text-primary rounded-circle avatar-sm mr-4 text-center"
            [ngClass]="{'bg-them-danger-1 text-primary': step > 3, 'bg-secondary text-primary': step == 3, 'border border-3 border-theme-alternate text-primary': step < 3}">
            3
          </h5>
        </div>
        <div class="col-md-9 d-flex align-items-center">
          <button class="btn btn-link h6  text-primary text-decoration-none" [disabled]="step < 3"
            style="cursor: default;" [routerLink]="['/employee/profile/thumb']">
            Photo & Sign
            <i-bs *ngIf="step > 3" name="check-circle-fill" class="text-success ml-2"></i-bs>
          </button>
        </div>
      </div>
    </li>
    <li class="my-3">
      <div class="row">
        <div class="col-md-2">
          <h5
            class="h5 d-flex align-items-center justify-content-center  text-primary rounded-circle avatar-sm mr-4 text-center"
            [ngClass]="{'bg-them-danger-1 text-primary': step > 4, 'bg-secondary text-primary': step == 4, 'border border-3 border-theme-alternate text-primary': step < 4}">
            4
          </h5>
        </div>
        <div class="col-md-10 d-flex align-items-center">
          <button class="btn btn-link h6  text-primary text-decoration-none" [disabled]="step < 4"
            style="cursor: default;" [routerLink]="['/employee/service-book/present-place']">
            Present Place/School
            <i-bs *ngIf="step > 4" name="check-circle-fill" class="text-success ml-2"></i-bs>
          </button>
        </div>
      </div>
    </li>
    <li class="my-3">
      <div class="row">
        <div class="col-md-2">
          <h5
            class="h5 d-flex align-items-center justify-content-center  text-primary rounded-circle avatar-sm mr-4 text-center"
            [ngClass]="{'bg-them-danger-1 text-primary': step > 5, 'bg-secondary text-primary': step == 5, 'border border-3 border-theme-alternate text-primary': step < 5}">
            5
          </h5>
        </div>
        <div class="col-md-9 d-flex align-items-center">
          <button class="btn btn-link h6  text-primary text-decoration-none" [disabled]="step < 5"
            style="cursor: default;" [routerLink]="['/employee/service-book']">
            Service Record
            <i-bs *ngIf="step > 5" name="check-circle-fill" class="text-success ml-2"></i-bs>
          </button>
        </div>
      </div>
    </li>

    <li class="my-3">
      <div class="row">
        <div class="col-md-2">
          <h5
            class="h5 d-flex align-items-center justify-content-center  text-primary rounded-circle avatar-sm mr-4 text-center"
            [ngClass]="{'bg-them-danger-1 text-primary': step > 6, 'bg-secondary text-primary': step == 6, 'border border-3 border-theme-alternate text-primary': step < 6}">
            6
          </h5>
        </div>
        <div class="col-md-9 d-flex align-items-center">
          <button class="btn btn-link h6  text-primary text-decoration-none" [disabled]="step < 6"
            style="cursor: default;" [routerLink]="['/employee/profile/other-details']">
            Priority Category
            <i-bs *ngIf="step > 6" name="check-circle-fill" class="text-success ml-2"></i-bs>
          </button>
        </div>
      </div>
    </li>
    <li class="my-3">
      <div class="row">
        <div class="col-md-2">
          <h5
            class="h5 d-flex align-items-center justify-content-center  text-primary rounded-circle avatar-sm mr-4 text-center"
            [ngClass]="{'bg-them-danger-1 text-primary': step > 7, 'bg-secondary text-primary': step == 7, 'border border-3 border-theme-alternate text-primary': step < 7}">
            7
          </h5>
        </div>
        <div class="col-md-9 d-flex align-items-center">
          <button class="btn btn-link h6  text-primary text-decoration-none" [disabled]="step < 7"
            style="cursor: default;" [routerLink]="['/employee/transfer-request']">
            Transfer Request
            <i-bs *ngIf="step > 7" name="check-circle-fill" class="text-success ml-2"></i-bs>
          </button>
        </div>
      </div>
    </li>
  </ul>
</div> -->
